// extracted by mini-css-extract-plugin
module.exports = {"container":"_2npJU_MJ8cmwNm2U50SbNi","groupsList":"_2PPtKcmBiZ5bBKFoOB97aD"};